import HelloModal from 'common/components/hello-modal';
import Button from 'hellospa/foundation/control/button';
import React from 'react';
import { FormattedMessage } from 'react-intl';

type Props = {
  onRequestClose: () => void
  isHelloFax: boolean
}
export function ThankYou({ onRequestClose, isHelloFax }: Props): JSX.Element {

  let message = <FormattedMessage
    id=""
    defaultMessage='Thanks for inviting your friends, we appreciate it.'
    description='contact import page, last step, marketing, thanking user for inviting new customers' />;

  if (isHelloFax) {
    message = <FormattedMessage
      id=""
      defaultMessage="Thanks for inviting your friends, we appreciate it. For each of your friends that signs up we\'ll credit your account with 5 free fax pages."
      description="contact import page, last step, marketing, thanking user for inviting new customers" />;
  }


  return (
    <HelloModal
      isOpen={true}
      showCloseIcon={true}
      onRequestClose={onRequestClose}
      buttons={[
        <Button key="submit" onClick={onRequestClose}>
          <FormattedMessage
            id=""
            defaultMessage='Continue'
            description='generic, usually link or button title, initiates next step in any arbitrary process.' />
        </Button>,
      ]}
    >
      {message}
    </HelloModal>
  );

}
